import { remove } from "../../../../../components/textfield/autocomplete-handler";
import clientPurchaseFullcont from "./clientPurchase-fullcont.html";

const dialog = require('../../../../../components/dialog/dialog')
const fullcontEntity = require('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler = require('../../../../../components/fullcont/fullcont-handler')
const clientPurchaseDt = require('./clientPurchase-dt')
const handler = require('./clientPurchase-fullcont-handler')
const { formCopy } = require('./clientPurchase-fullcont-form')
const { form } = require('./clientPurchase-fullcont-form')
const { clientPurchaseMT } = require('./clientPurchase-fullcont-multitable')

// const clientPurchaseMT   = undefined //no MT just add this like undefined

/****************ELEMENTS*****************/
var htmlFc = {}
var HTMLwasSelected = false

function HTMLselect(detail) {

      fullcontHandler.HTMLselect(

            'clientPurchase', //database table name****
            'clientPurchase', //dest entity on js
            'clientPurchase-fullcont',
            clientPurchaseFullcont, form, formCopy, clientPurchaseMT,
            editDialog, deleteDialog, dtCall, htmlFc)

      HTMLwasSelected = true

      // htmlFc.hasFiles = true
      // fullcontHandler.rightsControl(htmlFc)
}/**/


export function start(detail) {  //console.log('clientPurchase-dt 5>', clientPurchaseMT)

      if (!HTMLwasSelected) { HTMLselect(detail) }

      obj[detail.act].start(detail)
}/**/

const obj = {

      hide: { start: (detail) => { fullcontEntity.hide(detail, htmlFc) } },
      prepareEdit: { start: (detail) => { fullcontHandler.prepareEdit(detail, htmlFc) } },
      prepareView: { start: (detail) => { fullcontHandler.prepareView(detail, htmlFc) } },
      selectOne: { start: (detail) => { selectOne(detail, htmlFc) } },
      showMtlost: { start: (detail) => { handler.showMtlost(htmlFc) } },

}/**/



function selectOne(detail, htmlFc) {
      const entityFc = document.querySelector('#clientSale-fullcont');

      if (entityFc) {
            if (entityFc.classList.contains('fullcont-show')) {
                  entityFc.classList.remove('fullcont-show');
                  fullcontEntity.selectOne(detail, htmlFc, processAfterSelectOne);
                  return;
            }
      }

      fullcontEntity.selectOne(detail, htmlFc, processAfterSelectOne);
}/**/

function processAfterSelectOne(data, result) {
      handler.showLost();
}

//function to send
function editDialog() {
      dialog.start({ act: "show", id: "saveChanges", entity: 'clientPurchase' })
}

function deleteDialog(detail) {
      dialog.start({ act: "show", dest: 'clientPurchase', id: "deleteElem", entity: 'clientPurchase', dbid: detail.dbid })
}

function dtCall(act, result) {
      clientPurchaseDt.start({ act: act, row: result })
}